var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230.891,
    height: 230.891,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 88.5073H3.84961V96.2037H11.546V88.5073Z",
    fill: "#111920"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 119.293H3.84961V126.99H11.546V119.293Z",
    fill: "#111920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 142.385H3.84961V150.082H11.546V142.385Z",
    fill: "#111920"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 150.077H3.84961V157.773H11.546V150.077Z",
    fill: "#111920"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 96.2036H11.5454V103.9H19.2418V96.2036Z",
    fill: "#111920"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 119.293H11.5454V126.99H19.2418V119.293Z",
    fill: "#111920"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 126.989H11.5454V134.686H19.2418V126.989Z",
    fill: "#111920"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 142.385H11.5454V150.082H19.2418V142.385Z",
    fill: "#111920"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 150.077H11.5454V157.773H19.2418V150.077Z",
    fill: "#111920"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 73.1162H19.2412V80.8126H26.9376V73.1162Z",
    fill: "#111920"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 80.8135H19.2412V88.5098H26.9376V80.8135Z",
    fill: "#111920"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 96.2036H19.2412V103.9H26.9376V96.2036Z",
    fill: "#111920"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 103.899H19.2412V111.595H26.9376V103.899Z",
    fill: "#111920"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 111.598H19.2412V119.294H26.9376V111.598Z",
    fill: "#111920"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 119.293H19.2412V126.99H26.9376V119.293Z",
    fill: "#111920"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 134.69H19.2412V142.386H26.9376V134.69Z",
    fill: "#111920"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 65.4204H26.938V73.1168H34.6343V65.4204Z",
    fill: "#111920"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 73.1162H26.938V80.8126H34.6343V73.1162Z",
    fill: "#111920"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 80.8135H26.938V88.5098H34.6343V80.8135Z",
    fill: "#111920"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 88.5073H26.938V96.2037H34.6343V88.5073Z",
    fill: "#111920"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 126.989H26.938V134.686H34.6343V126.989Z",
    fill: "#111920"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 134.69H26.938V142.386H34.6343V134.69Z",
    fill: "#111920"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 142.385H26.938V150.082H34.6343V142.385Z",
    fill: "#111920"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 150.077H26.938V157.773H34.6343V150.077Z",
    fill: "#111920"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 73.1162H34.6367V80.8126H42.3331V73.1162Z",
    fill: "#111920"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 88.5073H34.6367V96.2037H42.3331V88.5073Z",
    fill: "#111920"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 119.293H34.6367V126.99H42.3331V119.293Z",
    fill: "#111920"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 134.69H34.6367V142.386H42.3331V134.69Z",
    fill: "#111920"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 157.775H34.6367V165.471H42.3331V157.775Z",
    fill: "#111920"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 65.4204H42.3311V73.1168H50.0274V65.4204Z",
    fill: "#111920"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 73.1162H42.3311V80.8126H50.0274V73.1162Z",
    fill: "#111920"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 80.8135H42.3311V88.5098H50.0274V80.8135Z",
    fill: "#111920"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 103.899H42.3311V111.595H50.0274V103.899Z",
    fill: "#111920"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 111.598H42.3311V119.294H50.0274V111.598Z",
    fill: "#111920"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 126.989H42.3311V134.686H50.0274V126.989Z",
    fill: "#111920"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 157.775H42.3311V165.471H50.0274V157.775Z",
    fill: "#111920"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 65.4204H50.0273V73.1168H57.7237V65.4204Z",
    fill: "#111920"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 80.8135H50.0273V88.5098H57.7237V80.8135Z",
    fill: "#111920"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 96.2036H50.0273V103.9H57.7237V96.2036Z",
    fill: "#111920"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 111.598H50.0273V119.294H57.7237V111.598Z",
    fill: "#111920"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 126.989H50.0273V134.686H57.7237V126.989Z",
    fill: "#111920"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 142.385H50.0273V150.082H57.7237V142.385Z",
    fill: "#111920"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 157.775H50.0273V165.471H57.7237V157.775Z",
    fill: "#111920"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 65.4204H57.7261V73.1168H65.4224V65.4204Z",
    fill: "#111920"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 73.1162H57.7261V80.8126H65.4224V73.1162Z",
    fill: "#111920"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 88.5073H57.7261V96.2037H65.4224V88.5073Z",
    fill: "#111920"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 96.2036H57.7261V103.9H65.4224V96.2036Z",
    fill: "#111920"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 103.899H57.7261V111.595H65.4224V103.899Z",
    fill: "#111920"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 111.598H57.7261V119.294H65.4224V111.598Z",
    fill: "#111920"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 119.293H57.7261V126.99H65.4224V119.293Z",
    fill: "#111920"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 126.989H57.7261V134.686H65.4224V126.989Z",
    fill: "#111920"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 142.385H57.7261V150.082H65.4224V142.385Z",
    fill: "#111920"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4224 157.775H57.7261V165.471H65.4224V157.775Z",
    fill: "#111920"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 11.5449H65.4194V19.2413H73.1158V11.5449Z",
    fill: "#111920"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 19.2402H65.4194V26.9366H73.1158V19.2402Z",
    fill: "#111920"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 50.0264H65.4194V57.7227H73.1158V50.0264Z",
    fill: "#111920"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 73.1162H65.4194V80.8126H73.1158V73.1162Z",
    fill: "#111920"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 80.8135H65.4194V88.5098H73.1158V80.8135Z",
    fill: "#111920"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 88.5073H65.4194V96.2037H73.1158V88.5073Z",
    fill: "#111920"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 103.899H65.4194V111.595H73.1158V103.899Z",
    fill: "#111920"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 119.293H65.4194V126.99H73.1158V119.293Z",
    fill: "#111920"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 126.989H65.4194V134.686H73.1158V126.989Z",
    fill: "#111920"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 134.69H65.4194V142.386H73.1158V134.69Z",
    fill: "#111920"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 142.385H65.4194V150.082H73.1158V142.385Z",
    fill: "#111920"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 150.077H65.4194V157.773H73.1158V150.077Z",
    fill: "#111920"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 157.775H65.4194V165.471H73.1158V157.775Z",
    fill: "#111920"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 173.168H65.4194V180.864H73.1158V173.168Z",
    fill: "#111920"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 180.864H65.4194V188.56H73.1158V180.864Z",
    fill: "#111920"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1158 196.258H65.4194V203.954H73.1158V196.258Z",
    fill: "#111920"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 3.84863H73.1182V11.545H80.8145V3.84863Z",
    fill: "#111920"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 11.5449H73.1182V19.2413H80.8145V11.5449Z",
    fill: "#111920"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 19.2402H73.1182V26.9366H80.8145V19.2402Z",
    fill: "#111920"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 26.9355H73.1182V34.6319H80.8145V26.9355Z",
    fill: "#111920"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 34.6362H73.1182V42.3326H80.8145V34.6362Z",
    fill: "#111920"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 42.3276H73.1182V50.024H80.8145V42.3276Z",
    fill: "#111920"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 57.7241H73.1182V65.4205H80.8145V57.7241Z",
    fill: "#111920"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 73.1162H73.1182V80.8126H80.8145V73.1162Z",
    fill: "#111920"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 80.8135H73.1182V88.5098H80.8145V80.8135Z",
    fill: "#111920"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 96.2036H73.1182V103.9H80.8145V96.2036Z",
    fill: "#111920"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 111.598H73.1182V119.294H80.8145V111.598Z",
    fill: "#111920"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 142.385H73.1182V150.082H80.8145V142.385Z",
    fill: "#111920"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 173.168H73.1182V180.864H80.8145V173.168Z",
    fill: "#111920"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 180.864H73.1182V188.56H80.8145V180.864Z",
    fill: "#111920"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 196.258H73.1182V203.954H80.8145V196.258Z",
    fill: "#111920"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 203.951H73.1182V211.648H80.8145V203.951Z",
    fill: "#111920"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 211.648H73.1182V219.344H80.8145V211.648Z",
    fill: "#111920"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8145 219.343H73.1182V227.04H80.8145V219.343Z",
    fill: "#111920"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 19.2402H80.8149V26.9366H88.5113V19.2402Z",
    fill: "#111920"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 26.9355H80.8149V34.6319H88.5113V26.9355Z",
    fill: "#111920"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 34.6362H80.8149V42.3326H88.5113V34.6362Z",
    fill: "#111920"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 50.0264H80.8149V57.7227H88.5113V50.0264Z",
    fill: "#111920"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 65.4204H80.8149V73.1168H88.5113V65.4204Z",
    fill: "#111920"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 73.1162H80.8149V80.8126H88.5113V73.1162Z",
    fill: "#111920"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 88.5073H80.8149V96.2037H88.5113V88.5073Z",
    fill: "#111920"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 96.2036H80.8149V103.9H88.5113V96.2036Z",
    fill: "#111920"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 119.293H80.8149V126.99H88.5113V119.293Z",
    fill: "#111920"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 134.69H80.8149V142.386H88.5113V134.69Z",
    fill: "#111920"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 142.385H80.8149V150.082H88.5113V142.385Z",
    fill: "#111920"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 150.077H80.8149V157.773H88.5113V150.077Z",
    fill: "#111920"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 157.775H80.8149V165.471H88.5113V157.775Z",
    fill: "#111920"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 165.473H80.8149V173.169H88.5113V165.473Z",
    fill: "#111920"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 180.864H80.8149V188.56H88.5113V180.864Z",
    fill: "#111920"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 188.562H80.8149V196.259H88.5113V188.562Z",
    fill: "#111920"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5113 219.343H80.8149V227.04H88.5113V219.343Z",
    fill: "#111920"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 11.5449H88.5078V19.2413H96.2042V11.5449Z",
    fill: "#111920"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 19.2402H88.5078V26.9366H96.2042V19.2402Z",
    fill: "#111920"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 26.9355H88.5078V34.6319H96.2042V26.9355Z",
    fill: "#111920"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 57.7241H88.5078V65.4205H96.2042V57.7241Z",
    fill: "#111920"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 80.8135H88.5078V88.5098H96.2042V80.8135Z",
    fill: "#111920"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 142.385H88.5078V150.082H96.2042V142.385Z",
    fill: "#111920"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 157.775H88.5078V165.471H96.2042V157.775Z",
    fill: "#111920"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 173.168H88.5078V180.864H96.2042V173.168Z",
    fill: "#111920"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 188.562H88.5078V196.259H96.2042V188.562Z",
    fill: "#111920"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2042 196.258H88.5078V203.954H96.2042V196.258Z",
    fill: "#111920"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 19.2402H96.2061V26.9366H103.902V19.2402Z",
    fill: "#111920"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 26.9355H96.2061V34.6319H103.902V26.9355Z",
    fill: "#111920"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 42.3276H96.2061V50.024H103.902V42.3276Z",
    fill: "#111920"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 50.0264H96.2061V57.7227H103.902V50.0264Z",
    fill: "#111920"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 65.4204H96.2061V73.1168H103.902V65.4204Z",
    fill: "#111920"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 73.1162H96.2061V80.8126H103.902V73.1162Z",
    fill: "#111920"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 80.8135H96.2061V88.5098H103.902V80.8135Z",
    fill: "#111920"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 150.077H96.2061V157.773H103.902V150.077Z",
    fill: "#111920"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 157.775H96.2061V165.471H103.902V157.775Z",
    fill: "#111920"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 165.473H96.2061V173.169H103.902V165.473Z",
    fill: "#111920"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 173.168H96.2061V180.864H103.902V173.168Z",
    fill: "#111920"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 211.648H96.2061V219.344H103.902V211.648Z",
    fill: "#111920"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 3.84863H103.904V11.545H111.601V3.84863Z",
    fill: "#111920"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 19.2402H103.904V26.9366H111.601V19.2402Z",
    fill: "#111920"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 42.3276H103.904V50.024H111.601V42.3276Z",
    fill: "#111920"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 142.385H103.904V150.082H111.601V142.385Z",
    fill: "#111920"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 150.077H103.904V157.773H111.601V150.077Z",
    fill: "#111920"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 157.775H103.904V165.471H111.601V157.775Z",
    fill: "#111920"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 173.168H103.904V180.864H111.601V173.168Z",
    fill: "#111920"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 196.258H103.904V203.954H111.601V196.258Z",
    fill: "#111920"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M111.601 219.344H103.904V227.04H111.601V219.344Z",
    fill: "#111920"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 34.6362H111.597V42.3326H119.293V34.6362Z",
    fill: "#111920"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 42.3276H111.597V50.024H119.293V42.3276Z",
    fill: "#111920"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 50.0264H111.597V57.7227H119.293V50.0264Z",
    fill: "#111920"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 73.1162H111.597V80.8126H119.293V73.1162Z",
    fill: "#111920"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 80.8135H111.597V88.5098H119.293V80.8135Z",
    fill: "#111920"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 150.077H111.597V157.773H119.293V150.077Z",
    fill: "#111920"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 165.473H111.597V173.169H119.293V165.473Z",
    fill: "#111920"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 173.168H111.597V180.864H119.293V173.168Z",
    fill: "#111920"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 196.258H111.597V203.954H119.293V196.258Z",
    fill: "#111920"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 203.951H111.597V211.648H119.293V203.951Z",
    fill: "#111920"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 211.648H111.597V219.344H119.293V211.648Z",
    fill: "#111920"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M119.293 219.344H111.597V227.04H119.293V219.344Z",
    fill: "#111920"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 11.5449H119.297V19.2413H126.993V11.5449Z",
    fill: "#111920"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 26.9355H119.297V34.6319H126.993V26.9355Z",
    fill: "#111920"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 34.6362H119.297V42.3326H126.993V34.6362Z",
    fill: "#111920"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 57.7246H119.297V65.421H126.993V57.7246Z",
    fill: "#111920"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 65.4204H119.297V73.1168H126.993V65.4204Z",
    fill: "#111920"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 73.1162H119.297V80.8126H126.993V73.1162Z",
    fill: "#111920"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 80.8135H119.297V88.5098H126.993V80.8135Z",
    fill: "#111920"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 157.775H119.297V165.471H126.993V157.775Z",
    fill: "#111920"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 165.473H119.297V173.169H126.993V165.473Z",
    fill: "#111920"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 173.168H119.297V180.864H126.993V173.168Z",
    fill: "#111920"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 196.258H119.297V203.954H126.993V196.258Z",
    fill: "#111920"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M126.993 211.648H119.297V219.344H126.993V211.648Z",
    fill: "#111920"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 19.2402H126.992V26.9366H134.689V19.2402Z",
    fill: "#111920"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 34.6362H126.992V42.3326H134.689V34.6362Z",
    fill: "#111920"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 50.0264H126.992V57.7227H134.689V50.0264Z",
    fill: "#111920"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 65.4204H126.992V73.1168H134.689V65.4204Z",
    fill: "#111920"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 173.168H126.992V180.864H134.689V173.168Z",
    fill: "#111920"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 180.864H126.992V188.56H134.689V180.864Z",
    fill: "#111920"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M134.689 188.562H126.992V196.259H134.689V188.562Z",
    fill: "#111920"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 11.5449H134.687V19.2413H142.383V11.5449Z",
    fill: "#111920"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 26.9355H134.687V34.6319H142.383V26.9355Z",
    fill: "#111920"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 34.6362H134.687V42.3326H142.383V34.6362Z",
    fill: "#111920"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 57.7246H134.687V65.421H142.383V57.7246Z",
    fill: "#111920"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 80.8135H134.687V88.5098H142.383V80.8135Z",
    fill: "#111920"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 150.077H134.687V157.773H142.383V150.077Z",
    fill: "#111920"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 157.775H134.687V165.471H142.383V157.775Z",
    fill: "#111920"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 165.473H134.687V173.169H142.383V165.473Z",
    fill: "#111920"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 173.168H134.687V180.864H142.383V173.168Z",
    fill: "#111920"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 180.864H134.687V188.56H142.383V180.864Z",
    fill: "#111920"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 196.258H134.687V203.954H142.383V196.258Z",
    fill: "#111920"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M142.383 219.344H134.687V227.04H142.383V219.344Z",
    fill: "#111920"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 3.84863H142.383V11.545H150.08V3.84863Z",
    fill: "#111920"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 11.5449H142.383V19.2413H150.08V11.5449Z",
    fill: "#111920"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 26.9355H142.383V34.6319H150.08V26.9355Z",
    fill: "#111920"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 34.6362H142.383V42.3326H150.08V34.6362Z",
    fill: "#111920"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 42.3276H142.383V50.024H150.08V42.3276Z",
    fill: "#111920"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 50.0264H142.383V57.7227H150.08V50.0264Z",
    fill: "#111920"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 57.7246H142.383V65.421H150.08V57.7246Z",
    fill: "#111920"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 88.5073H142.383V96.2037H150.08V88.5073Z",
    fill: "#111920"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 111.598H142.383V119.294H150.08V111.598Z",
    fill: "#111920"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 119.293H142.383V126.99H150.08V119.293Z",
    fill: "#111920"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 142.385H142.383V150.082H150.08V142.385Z",
    fill: "#111920"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 150.077H142.383V157.773H150.08V150.077Z",
    fill: "#111920"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 196.258H142.383V203.954H150.08V196.258Z",
    fill: "#111920"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 203.951H142.383V211.648H150.08V203.951Z",
    fill: "#111920"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M150.08 219.344H142.383V227.04H150.08V219.344Z",
    fill: "#111920"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 26.9355H150.083V34.6319H157.779V26.9355Z",
    fill: "#111920"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 42.3276H150.083V50.024H157.779V42.3276Z",
    fill: "#111920"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 57.7246H150.083V65.421H157.779V57.7246Z",
    fill: "#111920"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 73.1162H150.083V80.8126H157.779V73.1162Z",
    fill: "#111920"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 80.8135H150.083V88.5098H157.779V80.8135Z",
    fill: "#111920"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 96.2036H150.083V103.9H157.779V96.2036Z",
    fill: "#111920"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 103.899H150.083V111.595H157.779V103.899Z",
    fill: "#111920"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 165.473H150.083V173.169H157.779V165.473Z",
    fill: "#111920"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 173.168H150.083V180.864H157.779V173.168Z",
    fill: "#111920"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 180.864H150.083V188.56H157.779V180.864Z",
    fill: "#111920"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M157.779 219.344H150.083V227.04H157.779V219.344Z",
    fill: "#111920"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 3.84863H157.776V11.545H165.472V3.84863Z",
    fill: "#111920"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 11.5449H157.776V19.2413H165.472V11.5449Z",
    fill: "#111920"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 26.9355H157.776V34.6319H165.472V26.9355Z",
    fill: "#111920"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 50.0264H157.776V57.7227H165.472V50.0264Z",
    fill: "#111920"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 57.7246H157.776V65.421H165.472V57.7246Z",
    fill: "#111920"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 73.1162H157.776V80.8126H165.472V73.1162Z",
    fill: "#111920"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 88.5073H157.776V96.2037H165.472V88.5073Z",
    fill: "#111920"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 96.2036H157.776V103.9H165.472V96.2036Z",
    fill: "#111920"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 103.899H157.776V111.595H165.472V103.899Z",
    fill: "#111920"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 119.293H157.776V126.99H165.472V119.293Z",
    fill: "#111920"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 126.989H157.776V134.686H165.472V126.989Z",
    fill: "#111920"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 142.385H157.776V150.082H165.472V142.385Z",
    fill: "#111920"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 150.077H157.776V157.773H165.472V150.077Z",
    fill: "#111920"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 157.775H157.776V165.471H165.472V157.775Z",
    fill: "#111920"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 165.473H157.776V173.169H165.472V165.473Z",
    fill: "#111920"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 173.168H157.776V180.864H165.472V173.168Z",
    fill: "#111920"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 180.864H157.776V188.56H165.472V180.864Z",
    fill: "#111920"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 188.562H157.776V196.259H165.472V188.562Z",
    fill: "#111920"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M165.472 211.648H157.776V219.344H165.472V211.648Z",
    fill: "#111920"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 65.4204H165.473V73.1168H173.169V65.4204Z",
    fill: "#111920"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 80.8135H165.473V88.5098H173.169V80.8135Z",
    fill: "#111920"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 103.899H165.473V111.595H173.169V103.899Z",
    fill: "#111920"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 119.293H165.473V126.99H173.169V119.293Z",
    fill: "#111920"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 126.989H165.473V134.686H173.169V126.989Z",
    fill: "#111920"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 157.775H165.473V165.471H173.169V157.775Z",
    fill: "#111920"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 188.562H165.473V196.259H173.169V188.562Z",
    fill: "#111920"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 196.258H165.473V203.954H173.169V196.258Z",
    fill: "#111920"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M173.169 219.344H165.473V227.04H173.169V219.344Z",
    fill: "#111920"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 88.5073H173.17V96.2037H180.867V88.5073Z",
    fill: "#111920"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 103.899H173.17V111.595H180.867V103.899Z",
    fill: "#111920"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 119.293H173.17V126.99H180.867V119.293Z",
    fill: "#111920"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 134.69H173.17V142.386H180.867V134.69Z",
    fill: "#111920"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 142.385H173.17V150.082H180.867V142.385Z",
    fill: "#111920"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 157.775H173.17V165.471H180.867V157.775Z",
    fill: "#111920"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 173.168H173.17V180.864H180.867V173.168Z",
    fill: "#111920"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 188.562H173.17V196.259H180.867V188.562Z",
    fill: "#111920"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 196.258H173.17V203.954H180.867V196.258Z",
    fill: "#111920"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 203.951H173.17V211.648H180.867V203.951Z",
    fill: "#111920"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M180.867 219.344H173.17V227.04H180.867V219.344Z",
    fill: "#111920"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 73.1162H180.864V80.8126H188.561V73.1162Z",
    fill: "#111920"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 80.8135H180.864V88.5098H188.561V80.8135Z",
    fill: "#111920"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 96.2036H180.864V103.9H188.561V96.2036Z",
    fill: "#111920"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 103.899H180.864V111.595H188.561V103.899Z",
    fill: "#111920"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 111.598H180.864V119.294H188.561V111.598Z",
    fill: "#111920"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 119.293H180.864V126.99H188.561V119.293Z",
    fill: "#111920"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 142.385H180.864V150.082H188.561V142.385Z",
    fill: "#111920"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 150.077H180.864V157.773H188.561V150.077Z",
    fill: "#111920"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 157.775H180.864V165.471H188.561V157.775Z",
    fill: "#111920"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 188.562H180.864V196.259H188.561V188.562Z",
    fill: "#111920"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 196.258H180.864V203.954H188.561V196.258Z",
    fill: "#111920"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 211.648H180.864V219.344H188.561V211.648Z",
    fill: "#111920"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M188.561 219.344H180.864V227.04H188.561V219.344Z",
    fill: "#111920"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 73.1162H188.564V80.8126H196.26V73.1162Z",
    fill: "#111920"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 103.899H188.564V111.595H196.26V103.899Z",
    fill: "#111920"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 111.598H188.564V119.294H196.26V111.598Z",
    fill: "#111920"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 119.293H188.564V126.99H196.26V119.293Z",
    fill: "#111920"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 126.989H188.564V134.686H196.26V126.989Z",
    fill: "#111920"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 134.69H188.564V142.386H196.26V134.69Z",
    fill: "#111920"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 142.385H188.564V150.082H196.26V142.385Z",
    fill: "#111920"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 150.077H188.564V157.773H196.26V150.077Z",
    fill: "#111920"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 157.775H188.564V165.471H196.26V157.775Z",
    fill: "#111920"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 165.473H188.564V173.169H196.26V165.473Z",
    fill: "#111920"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 173.168H188.564V180.864H196.26V173.168Z",
    fill: "#111920"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 180.864H188.564V188.56H196.26V180.864Z",
    fill: "#111920"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 188.562H188.564V196.259H196.26V188.562Z",
    fill: "#111920"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 80.8135H196.261V88.5098H203.957V80.8135Z",
    fill: "#111920"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 126.989H196.261V134.686H203.957V126.989Z",
    fill: "#111920"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 134.69H196.261V142.386H203.957V134.69Z",
    fill: "#111920"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 142.385H196.261V150.082H203.957V142.385Z",
    fill: "#111920"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 150.077H196.261V157.773H203.957V150.077Z",
    fill: "#111920"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 157.775H196.261V165.471H203.957V157.775Z",
    fill: "#111920"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 180.864H196.261V188.56H203.957V180.864Z",
    fill: "#111920"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 188.562H196.261V196.259H203.957V188.562Z",
    fill: "#111920"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M203.957 211.648H196.261V219.344H203.957V211.648Z",
    fill: "#111920"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 65.4204H203.952V73.1168H211.649V65.4204Z",
    fill: "#111920"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 80.8135H203.952V88.5098H211.649V80.8135Z",
    fill: "#111920"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 96.2036H203.952V103.9H211.649V96.2036Z",
    fill: "#111920"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 126.989H203.952V134.686H211.649V126.989Z",
    fill: "#111920"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 165.473H203.952V173.169H211.649V165.473Z",
    fill: "#111920"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 188.562H203.952V196.259H211.649V188.562Z",
    fill: "#111920"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 203.951H203.952V211.648H211.649V203.951Z",
    fill: "#111920"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 211.648H203.952V219.344H211.649V211.648Z",
    fill: "#111920"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 219.344H203.952V227.04H211.649V219.344Z",
    fill: "#111920"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 65.4204H211.652V73.1168H219.348V65.4204Z",
    fill: "#111920"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 80.8135H211.652V88.5098H219.348V80.8135Z",
    fill: "#111920"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 96.2036H211.652V103.9H219.348V96.2036Z",
    fill: "#111920"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 111.598H211.652V119.294H219.348V111.598Z",
    fill: "#111920"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 119.293H211.652V126.99H219.348V119.293Z",
    fill: "#111920"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 126.989H211.652V134.686H219.348V126.989Z",
    fill: "#111920"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 157.775H211.652V165.471H219.348V157.775Z",
    fill: "#111920"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 196.258H211.652V203.954H219.348V196.258Z",
    fill: "#111920"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 88.5073H219.348V96.2037H227.045V88.5073Z",
    fill: "#111920"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 103.899H219.348V111.595H227.045V103.899Z",
    fill: "#111920"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 126.989H219.348V134.686H227.045V126.989Z",
    fill: "#111920"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 157.775H219.348V165.471H227.045V157.775Z",
    fill: "#111920"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 188.562H219.348V196.259H227.045V188.562Z",
    fill: "#111920"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 196.258H219.348V203.954H227.045V196.258Z",
    fill: "#111920"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 203.951H219.348V211.648H227.045V203.951Z",
    fill: "#111920"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M227.045 219.344H219.348V227.04H227.045V219.344Z",
    fill: "#111920"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 3.84863H3.84961V11.545H11.546V3.84863Z",
    fill: "#111920"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 11.5449H3.84961V19.2413H11.546V11.5449Z",
    fill: "#111920"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 19.2402H3.84961V26.9366H11.546V19.2402Z",
    fill: "#111920"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 26.9355H3.84961V34.6319H11.546V26.9355Z",
    fill: "#111920"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 34.6362H3.84961V42.3326H11.546V34.6362Z",
    fill: "#111920"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 42.3276H3.84961V50.024H11.546V42.3276Z",
    fill: "#111920"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 50.0264H3.84961V57.7227H11.546V50.0264Z",
    fill: "#111920"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 3.84863H11.5454V11.545H19.2418V3.84863Z",
    fill: "#111920"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2418 50.0264H11.5454V57.7227H19.2418V50.0264Z",
    fill: "#111920"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 3.84863H19.2412V11.545H26.9376V3.84863Z",
    fill: "#111920"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9376 50.0264H19.2412V57.7227H26.9376V50.0264Z",
    fill: "#111920"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 3.84863H26.938V11.545H34.6343V3.84863Z",
    fill: "#111920"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 50.0264H26.938V57.7227H34.6343V50.0264Z",
    fill: "#111920"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 3.84863H34.6367V11.545H42.3331V3.84863Z",
    fill: "#111920"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 50.0264H34.6367V57.7227H42.3331V50.0264Z",
    fill: "#111920"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 3.84863H42.3311V11.545H50.0274V3.84863Z",
    fill: "#111920"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0274 50.0264H42.3311V57.7227H50.0274V50.0264Z",
    fill: "#111920"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 3.84863H50.0273V11.545H57.7237V3.84863Z",
    fill: "#111920"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 11.5449H50.0273V19.2413H57.7237V11.5449Z",
    fill: "#111920"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 19.2402H50.0273V26.9366H57.7237V19.2402Z",
    fill: "#111920"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 26.9355H50.0273V34.6319H57.7237V26.9355Z",
    fill: "#111920"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 34.6362H50.0273V42.3326H57.7237V34.6362Z",
    fill: "#111920"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 42.3276H50.0273V50.024H57.7237V42.3276Z",
    fill: "#111920"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7237 50.0264H50.0273V57.7227H57.7237V50.0264Z",
    fill: "#111920"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 19.2412H19.2441V26.9376H26.9405V19.2412Z",
    fill: "#111920"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 26.9365H19.2441V34.6329H26.9405V26.9365Z",
    fill: "#111920"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 34.6328H19.2441V42.3292H26.9405V34.6328Z",
    fill: "#111920"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 19.2412H26.9399V26.9376H34.6363V19.2412Z",
    fill: "#111920"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 26.9365H26.9399V34.6329H34.6363V26.9365Z",
    fill: "#111920"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 34.6328H26.9399V42.3292H34.6363V34.6328Z",
    fill: "#111920"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 19.2412H34.6367V26.9376H42.3331V19.2412Z",
    fill: "#111920"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 26.9365H34.6367V34.6329H42.3331V26.9365Z",
    fill: "#111920"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3331 34.6328H34.6367V42.3292H42.3331V34.6328Z",
    fill: "#111920"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 3.84912H173.169V11.5455H180.866V3.84912Z",
    fill: "#111920"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 11.5449H173.169V19.2413H180.866V11.5449Z",
    fill: "#111920"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 19.2402H173.169V26.9366H180.866V19.2402Z",
    fill: "#111920"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 26.936H173.169V34.6324H180.866V26.936Z",
    fill: "#111920"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 34.6323H173.169V42.3287H180.866V34.6323Z",
    fill: "#111920"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 42.3276H173.169V50.024H180.866V42.3276Z",
    fill: "#111920"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M180.866 50.0264H173.169V57.7227H180.866V50.0264Z",
    fill: "#111920"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M188.562 3.84912H180.865V11.5455H188.562V3.84912Z",
    fill: "#111920"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M188.562 50.0264H180.865V57.7227H188.562V50.0264Z",
    fill: "#111920"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M196.257 3.84912H188.561V11.5455H196.257V3.84912Z",
    fill: "#111920"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M196.257 50.0264H188.561V57.7227H196.257V50.0264Z",
    fill: "#111920"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 3.84912H196.258V11.5455H203.954V3.84912Z",
    fill: "#111920"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 50.0264H196.258V57.7227H203.954V50.0264Z",
    fill: "#111920"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M211.652 3.84912H203.956V11.5455H211.652V3.84912Z",
    fill: "#111920"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M211.652 50.0264H203.956V57.7227H211.652V50.0264Z",
    fill: "#111920"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 3.84912H211.651V11.5455H219.348V3.84912Z",
    fill: "#111920"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M219.348 50.0264H211.651V57.7227H219.348V50.0264Z",
    fill: "#111920"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 3.84912H219.347V11.5455H227.043V3.84912Z",
    fill: "#111920"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 11.5449H219.347V19.2413H227.043V11.5449Z",
    fill: "#111920"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 19.2402H219.347V26.9366H227.043V19.2402Z",
    fill: "#111920"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 26.936H219.347V34.6324H227.043V26.936Z",
    fill: "#111920"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 34.6323H219.347V42.3287H227.043V34.6323Z",
    fill: "#111920"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 42.3276H219.347V50.024H227.043V42.3276Z",
    fill: "#111920"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M227.043 50.0264H219.347V57.7227H227.043V50.0264Z",
    fill: "#111920"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M196.258 19.2402H188.562V26.9366H196.258V19.2402Z",
    fill: "#111920"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M196.258 26.9365H188.562V34.6329H196.258V26.9365Z",
    fill: "#111920"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M196.258 34.6328H188.562V42.3292H196.258V34.6328Z",
    fill: "#111920"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 19.2402H196.258V26.9366H203.954V19.2402Z",
    fill: "#111920"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 26.9365H196.258V34.6329H203.954V26.9365Z",
    fill: "#111920"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M203.954 34.6328H196.258V42.3292H203.954V34.6328Z",
    fill: "#111920"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 19.2402H203.953V26.9366H211.649V19.2402Z",
    fill: "#111920"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 26.9365H203.953V34.6329H211.649V26.9365Z",
    fill: "#111920"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M211.649 34.6328H203.953V42.3292H211.649V34.6328Z",
    fill: "#111920"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 173.167H3.85059V180.863H11.5469V173.167Z",
    fill: "#111920"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 180.862H3.85059V188.559H11.5469V180.862Z",
    fill: "#111920"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 188.559H3.85059V196.255H11.5469V188.559Z",
    fill: "#111920"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 196.258H3.85059V203.954H11.5469V196.258Z",
    fill: "#111920"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 203.95H3.85059V211.647H11.5469V203.95Z",
    fill: "#111920"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 211.645H3.85059V219.341H11.5469V211.645Z",
    fill: "#111920"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 219.345H3.85059V227.042H11.5469V219.345Z",
    fill: "#111920"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2432 173.167H11.5469V180.863H19.2432V173.167Z",
    fill: "#111920"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2432 219.345H11.5469V227.042H19.2432V219.345Z",
    fill: "#111920"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M26.939 173.167H19.2427V180.863H26.939V173.167Z",
    fill: "#111920"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M26.939 219.345H19.2427V227.042H26.939V219.345Z",
    fill: "#111920"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6353 173.167H26.939V180.863H34.6353V173.167Z",
    fill: "#111920"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6353 219.345H26.939V227.042H34.6353V219.345Z",
    fill: "#111920"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3341 173.167H34.6377V180.863H42.3341V173.167Z",
    fill: "#111920"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3341 219.345H34.6377V227.042H42.3341V219.345Z",
    fill: "#111920"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0264 173.167H42.3301V180.863H50.0264V173.167Z",
    fill: "#111920"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0264 219.345H42.3301V227.042H50.0264V219.345Z",
    fill: "#111920"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 173.167H50.0283V180.863H57.7247V173.167Z",
    fill: "#111920"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 180.862H50.0283V188.559H57.7247V180.862Z",
    fill: "#111920"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 188.559H50.0283V196.255H57.7247V188.559Z",
    fill: "#111920"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 196.258H50.0283V203.954H57.7247V196.258Z",
    fill: "#111920"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 203.95H50.0283V211.647H57.7247V203.95Z",
    fill: "#111920"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 211.645H50.0283V219.341H57.7247V211.645Z",
    fill: "#111920"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7247 219.345H50.0283V227.042H57.7247V219.345Z",
    fill: "#111920"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 188.559H19.2441V196.255H26.9405V188.559Z",
    fill: "#111920"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 196.254H19.2441V203.951H26.9405V196.254Z",
    fill: "#111920"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9405 203.95H19.2441V211.646H26.9405V203.95Z",
    fill: "#111920"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 188.559H26.9399V196.255H34.6363V188.559Z",
    fill: "#111920"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 196.254H26.9399V203.951H34.6363V196.254Z",
    fill: "#111920"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6363 203.95H26.9399V211.646H34.6363V203.95Z",
    fill: "#111920"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3321 188.559H34.6357V196.255H42.3321V188.559Z",
    fill: "#111920"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3321 196.254H34.6357V203.951H42.3321V196.254Z",
    fill: "#111920"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3321 203.95H34.6357V211.646H42.3321V203.95Z",
    fill: "#111920"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 167.929,
    height: 64.9483,
    transform: "translate(31.4805 82.9712)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4753 115.95H53.111C52.4978 115.95 51.9098 116.194 51.4761 116.627C51.0425 117.061 50.7987 117.648 50.7983 118.262V130.627C50.7983 131.24 51.042 131.829 51.4757 132.262C51.9094 132.696 52.4976 132.94 53.111 132.94H65.4753C66.0886 132.94 66.6768 132.696 67.1105 132.262C67.5442 131.829 67.7879 131.24 67.7879 130.627V118.262C67.7876 117.648 67.5438 117.061 67.1101 116.627C66.6764 116.194 66.0884 115.95 65.4753 115.95Z",
    fill: "url(#paint0_linear_360_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4478 127.208C62.5634 127.457 61.7872 127.208 61.1364 126.564C61.0643 126.491 61.0122 126.406 60.9401 126.328C60.917 126.296 60.8846 126.271 60.8473 126.258C60.81 126.245 60.7696 126.244 60.7315 126.254C60.6942 126.263 60.6609 126.284 60.6365 126.314C60.6121 126.343 60.5979 126.38 60.5961 126.418C60.5925 126.465 60.6043 126.512 60.6296 126.552C61.0269 127.111 61.6252 127.494 62.2989 127.62C62.3535 127.632 62.3697 127.649 62.3697 127.702C62.3697 127.972 62.3697 128.241 62.3697 128.51C62.3747 128.558 62.3645 128.608 62.3406 128.65C62.3167 128.693 62.2803 128.727 62.2362 128.749C62.1921 128.77 62.1425 128.777 62.0942 128.769C62.0458 128.761 62.0011 128.739 61.966 128.705C61.6046 128.417 61.2444 128.126 60.8768 127.844C60.4633 127.523 59.9547 127.348 59.4311 127.347C58.7902 127.347 58.1505 127.347 57.5097 127.347H57.4314C57.5556 127.243 57.6798 127.15 57.7854 127.039C58.0909 126.719 58.2795 126.306 58.3207 125.866C58.3828 125.377 58.2462 124.925 58.0884 124.473C57.9945 124.216 57.9198 123.953 57.8649 123.685C57.8179 123.383 57.8771 123.075 58.0326 122.812C58.188 122.549 58.4299 122.349 58.7169 122.245C58.743 122.236 58.7691 122.229 58.7939 122.219C58.8397 122.201 58.8768 122.165 58.8974 122.121C58.918 122.076 58.9206 122.025 58.9047 121.978C58.8888 121.931 58.8555 121.892 58.8117 121.87C58.768 121.847 58.7172 121.842 58.6697 121.855C58.3657 121.952 58.0942 122.131 57.885 122.372C57.6757 122.613 57.5369 122.907 57.4836 123.221C57.4443 123.573 57.4868 123.929 57.6078 124.261C57.7034 124.551 57.8177 124.836 57.8947 125.13C57.9633 125.372 57.9794 125.625 57.942 125.874C57.9045 126.122 57.8142 126.359 57.6773 126.57C57.5618 126.751 57.4065 126.904 57.2232 127.017C57.0398 127.129 56.8333 127.198 56.6191 127.219C55.7982 127.33 54.5077 126.888 53.9811 125.782C53.7354 125.266 53.672 124.681 53.8013 124.124C53.9305 123.566 54.2448 123.069 54.6928 122.713C54.9387 122.513 55.215 122.353 55.5113 122.24C55.5139 122.255 55.5139 122.271 55.5113 122.286C55.3961 122.647 55.3494 123.026 55.3734 123.404C55.3943 123.815 55.5417 124.211 55.7957 124.535C55.8186 124.567 55.8512 124.591 55.8885 124.603C55.9259 124.614 55.966 124.614 56.0031 124.601C56.0395 124.594 56.0723 124.575 56.0964 124.547C56.1205 124.518 56.1345 124.483 56.136 124.446C56.1388 124.393 56.1244 124.34 56.095 124.296C55.7758 123.88 55.7224 123.403 55.7746 122.903C55.8298 122.309 56.0835 121.75 56.4949 121.317C56.8929 120.907 57.38 120.594 57.9184 120.402C58.4569 120.21 59.0322 120.145 59.6 120.211C60.0819 120.269 60.4831 120.474 60.7327 120.914C60.8176 121.065 60.8533 121.238 60.8348 121.411C60.8163 121.583 60.7446 121.745 60.6296 121.875C60.5404 121.968 60.4398 122.048 60.3303 122.116C60.221 122.189 60.175 122.295 60.2309 122.393C60.2449 122.417 60.2636 122.438 60.2859 122.454C60.3083 122.47 60.3337 122.482 60.3607 122.488C60.3877 122.494 60.4157 122.495 60.443 122.49C60.4702 122.485 60.4961 122.474 60.5191 122.459C60.7972 122.313 61.0165 122.075 61.1401 121.787C61.2121 121.85 61.2767 121.911 61.3512 121.973C61.5263 122.108 61.7353 122.193 61.9552 122.218C62.1751 122.242 62.3976 122.206 62.5982 122.112C62.6431 122.093 62.6786 122.056 62.6971 122.011C62.7157 121.966 62.7159 121.915 62.6976 121.87C62.6804 121.827 62.6483 121.792 62.6073 121.771C62.5662 121.749 62.5189 121.744 62.474 121.754C62.397 121.776 62.3225 121.809 62.243 121.824C62.0228 121.863 61.7961 121.817 61.6085 121.695C61.4209 121.573 61.2864 121.385 61.232 121.168C61.154 120.848 60.9875 120.556 60.7513 120.326C60.6718 120.255 60.5861 120.191 60.4955 120.116C61.011 120.187 61.5132 120.333 61.9859 120.551C62.7525 120.887 63.4034 121.44 63.8576 122.143C64.054 122.433 64.1896 122.76 64.2563 123.105C64.3153 123.412 64.2978 123.73 64.2054 124.03C64.034 124.548 63.608 124.782 63.0801 124.651C62.6824 124.532 62.311 124.339 61.9859 124.081C61.7369 123.879 61.4588 123.717 61.1612 123.599C60.9048 123.5 60.6194 123.506 60.3678 123.617C60.1163 123.728 59.9192 123.935 59.8198 124.191C59.7381 124.41 59.7351 124.651 59.8111 124.872C59.821 124.912 59.8428 124.947 59.8738 124.974C59.9047 125.001 59.9431 125.017 59.9838 125.021C60.0217 125.027 60.0603 125.019 60.0937 125C60.127 124.982 60.153 124.952 60.1676 124.917C60.1887 124.866 60.1926 124.81 60.1788 124.758C60.1433 124.662 60.1318 124.56 60.1454 124.459C60.1589 124.358 60.197 124.262 60.2564 124.179C60.3158 124.096 60.3946 124.029 60.4859 123.984C60.5772 123.939 60.6781 123.917 60.7799 123.921C60.925 123.925 61.0668 123.965 61.1935 124.036C61.4169 124.164 61.6333 124.305 61.8418 124.456C62.1768 124.711 62.5557 124.902 62.9596 125.02C63.2634 125.113 63.5904 125.095 63.8825 124.97C64.1715 124.831 64.4001 124.591 64.5258 124.296C64.5358 124.271 64.5469 124.247 64.5631 124.211C64.6652 124.381 64.7426 124.564 64.7929 124.755C65.0698 125.797 64.4712 126.929 63.4478 127.208Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5392 115.95H71.1737C70.5607 115.95 69.9728 116.194 69.5393 116.627C69.1058 117.061 68.8623 117.649 68.8623 118.262V130.627C68.8623 131.24 69.1058 131.828 69.5392 132.262C69.9727 132.696 70.5606 132.939 71.1737 132.94H83.5392C84.1524 132.939 84.7403 132.696 85.1737 132.262C85.6071 131.828 85.8506 131.24 85.8506 130.627V118.262C85.8506 117.649 85.6071 117.061 85.1736 116.627C84.7402 116.194 84.1522 115.95 83.5392 115.95Z",
    fill: "url(#paint1_linear_360_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6114 120.296H78.1505C78.1783 120.304 78.2065 120.309 78.2349 120.313C78.6537 120.338 79.0608 120.461 79.4242 120.67C79.7876 120.88 80.0973 121.171 80.329 121.521C80.95 122.412 81.032 123.384 80.7165 124.4C80.5344 124.978 80.2201 125.505 79.7986 125.94C79.4571 126.299 79.3242 126.734 79.2832 127.209C79.2403 127.794 79.2441 128.381 79.2944 128.964C79.2944 129.041 79.3018 129.118 79.3055 129.197H77.7033V129.089C77.7033 128.515 77.7033 127.941 77.7033 127.366C77.7083 127.192 77.6777 127.018 77.6133 126.856C77.5489 126.694 77.4521 126.547 77.3288 126.424C77.2056 126.301 77.0584 126.204 76.8964 126.139C76.7345 126.075 76.561 126.044 76.3868 126.049H74.0369L74.1102 125.938C74.2779 125.681 74.2505 125.545 73.9947 125.374C73.9177 125.323 73.8345 125.281 73.7575 125.228C73.6867 125.184 73.6198 125.133 73.5575 125.077C73.5287 125.052 73.5051 125.022 73.4882 124.988C73.4713 124.954 73.4613 124.917 73.459 124.879C73.4567 124.841 73.462 124.803 73.4747 124.767C73.4873 124.732 73.507 124.699 73.5326 124.671C73.5699 124.628 73.6115 124.59 73.6568 124.557C73.788 124.46 73.9125 124.354 74.0295 124.241C74.2779 123.96 74.3623 123.61 74.4021 123.247C74.4331 122.942 74.4455 122.635 74.4741 122.33C74.494 122.021 74.5939 121.723 74.764 121.465C74.9341 121.206 75.1685 120.997 75.4441 120.857C75.9856 120.556 76.5793 120.432 77.1829 120.349C77.3183 120.329 77.4649 120.314 77.6114 120.296Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1358 129.202C76.1358 129.017 76.1432 128.836 76.1358 128.658C76.1279 128.373 76.0742 128.092 75.9768 127.825C75.8526 127.504 75.6117 127.376 75.2676 127.422C75.059 127.453 74.8487 127.472 74.6379 127.48C74.5651 127.482 74.4925 127.47 74.4245 127.443C74.3565 127.417 74.2944 127.378 74.2417 127.327C74.1935 127.287 74.1582 127.234 74.1401 127.174C74.122 127.114 74.1219 127.05 74.1399 126.99C74.1622 126.903 74.1958 126.818 74.2243 126.734C74.2485 126.683 74.2611 126.628 74.2611 126.572C74.2611 126.516 74.2485 126.461 74.2243 126.411C74.2554 126.411 74.2777 126.411 74.3001 126.411C75.0006 126.411 75.7023 126.411 76.4041 126.411C76.616 126.407 76.8225 126.478 76.9885 126.609C77.1545 126.741 77.2697 126.926 77.3145 127.134C77.3294 127.202 77.3369 127.271 77.3368 127.341C77.3368 127.943 77.3368 128.546 77.3368 129.149C77.3368 129.166 77.3368 129.183 77.3368 129.205L76.1358 129.202Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4753 97.9502H53.111C52.4976 97.9502 51.9094 98.1938 51.4757 98.6276C51.042 99.0613 50.7983 99.6495 50.7983 100.263V112.628C50.7987 113.241 51.0425 113.829 51.4761 114.263C51.9098 114.696 52.4978 114.94 53.111 114.94H65.4753C66.0884 114.94 66.6764 114.696 67.1101 114.263C67.5438 113.829 67.7876 113.241 67.7879 112.628V100.263C67.7879 99.6495 67.5442 99.0613 67.1105 98.6276C66.6768 98.1938 66.0886 97.9502 65.4753 97.9502Z",
    fill: "url(#paint2_linear_360_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1273 107.461C63.1273 107.447 63.1273 107.433 63.1273 107.418C63.1254 107.375 63.1322 107.333 63.1474 107.294C63.1626 107.254 63.1858 107.219 63.2155 107.189C63.2452 107.159 63.2809 107.135 63.3202 107.12C63.3594 107.104 63.4015 107.097 63.4437 107.098C63.4859 107.1 63.5274 107.11 63.5654 107.129C63.6035 107.147 63.6373 107.173 63.6647 107.205C63.6922 107.237 63.7127 107.275 63.7249 107.315C63.7372 107.356 63.7409 107.398 63.7359 107.44C63.7359 108.158 63.4167 108.855 62.8168 109.456C62.3364 109.89 61.7145 110.136 61.0668 110.146H61.0482C61.0325 110.148 61.0167 110.148 61.001 110.146C60.9504 110.149 60.9004 110.135 60.8594 110.105C60.7808 110.051 60.7226 109.972 60.6942 109.881C60.6858 109.847 60.6843 109.812 60.6896 109.777C60.695 109.743 60.7071 109.71 60.7252 109.681C60.7712 109.616 60.8407 109.571 60.919 109.556C60.9597 109.547 61.0014 109.543 61.0432 109.544H61.0643C61.6033 109.522 62.1145 109.299 62.4965 108.918C62.8784 108.537 63.1031 108.026 63.1261 107.487C63.1261 107.478 63.1273 107.47 63.1273 107.461Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0059 107.418C62.0035 107.375 62.0101 107.332 62.0253 107.292C62.0405 107.252 62.0639 107.215 62.0941 107.185C62.1242 107.154 62.1604 107.13 62.2004 107.115C62.2403 107.099 62.2831 107.092 62.3259 107.094C62.3688 107.096 62.4108 107.107 62.4491 107.126C62.4875 107.145 62.5215 107.172 62.5488 107.205C62.5761 107.238 62.5961 107.277 62.6077 107.318C62.6192 107.359 62.622 107.403 62.6157 107.445C62.6035 107.86 62.4349 108.255 62.1438 108.55C61.8499 108.839 61.4586 109.007 61.0471 109.021H61.0247C60.9842 109.026 60.9433 109.022 60.9043 109.01C60.8654 108.998 60.8292 108.978 60.7981 108.952C60.767 108.926 60.7415 108.894 60.7233 108.857C60.705 108.821 60.6943 108.781 60.6919 108.74C60.688 108.702 60.692 108.663 60.7035 108.627C60.715 108.59 60.7339 108.556 60.7589 108.527C60.7922 108.491 60.8326 108.462 60.8774 108.442C60.9223 108.422 60.9707 108.412 61.0198 108.411C61.5911 108.375 61.9612 108.003 62.0059 107.418Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3137 107.816C60.1895 107.85 60.0653 107.881 59.9411 107.919C59.916 107.93 59.893 107.946 59.8728 107.965C59.8914 107.986 59.9038 108.014 59.9274 108.028C60.0864 108.122 60.2491 108.213 60.4081 108.307C60.5186 108.372 60.5323 108.409 60.4702 108.524C60.3599 108.738 60.1984 108.921 60.0002 109.058C59.8019 109.195 59.573 109.28 59.3337 109.307C59.1909 109.328 59.1685 109.344 59.1685 109.487V110.619H56.2486C56.2486 110.58 56.2486 110.541 56.2486 110.502C56.2486 110.138 56.2423 109.774 56.2486 109.409C56.2597 109.113 56.1781 108.821 56.0151 108.573C55.835 108.3 55.6424 108.034 55.4549 107.768C54.895 106.994 54.6147 106.053 54.66 105.099C54.6603 104.698 54.7292 104.3 54.8637 103.922C54.9913 103.558 55.2062 103.231 55.4894 102.97C55.7726 102.708 56.1155 102.52 56.4883 102.421C57.2541 102.181 58.0786 102.207 58.8282 102.494C59.8516 102.897 60.4056 103.682 60.567 104.756C60.5783 104.804 60.5842 104.852 60.5844 104.901C60.5596 105.149 60.6652 105.343 60.7782 105.545C61.0266 105.992 61.275 106.444 61.5147 106.894C61.6551 107.15 61.5532 107.325 61.2663 107.326C61.0949 107.326 60.9235 107.326 60.7533 107.326C60.6515 107.326 60.5969 107.366 60.5993 107.469C60.6105 107.777 60.6105 107.732 60.3137 107.816Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8456 107.578C64.8355 107.778 64.8127 107.977 64.7773 108.174C64.6233 108.944 64.2606 109.596 63.6346 110.226C62.934 110.893 62.0038 111.266 61.0363 111.267H61.0239C60.9786 111.269 60.9333 111.262 60.8907 111.246C60.8481 111.231 60.8089 111.207 60.7755 111.176C60.7476 111.148 60.7258 111.114 60.7113 111.077C60.6968 111.039 60.6899 111 60.691 110.96C60.6923 110.918 60.702 110.876 60.7197 110.838C60.7375 110.8 60.7628 110.765 60.7941 110.737C60.8255 110.709 60.8622 110.687 60.9021 110.674C60.9421 110.66 60.9843 110.655 61.0264 110.658H61.0736C61.8045 110.647 62.5092 110.384 63.0683 109.913C63.4281 109.621 63.7204 109.254 63.9251 108.838C64.1299 108.422 64.2422 107.967 64.2544 107.503C64.2538 107.491 64.2538 107.479 64.2544 107.467C64.2532 107.449 64.2532 107.43 64.2544 107.411C64.2527 107.37 64.2594 107.329 64.2742 107.29C64.289 107.252 64.3115 107.217 64.3403 107.187C64.3691 107.157 64.4037 107.134 64.4419 107.118C64.4801 107.102 64.5211 107.094 64.5624 107.095C64.6035 107.095 64.6441 107.103 64.6817 107.12C64.7193 107.136 64.7531 107.16 64.781 107.19C64.8106 107.224 64.8328 107.264 64.8463 107.306C64.8598 107.349 64.8642 107.394 64.8593 107.439C64.8518 107.485 64.8481 107.531 64.8456 107.578Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5392 97.9497H71.1737C70.5606 97.95 69.9727 98.1938 69.5392 98.6275C69.1058 99.0612 68.8623 99.6492 68.8623 100.262V112.628C68.8623 113.241 69.1058 113.829 69.5393 114.262C69.9728 114.696 70.5607 114.939 71.1737 114.939H83.5392C84.1522 114.939 84.7402 114.696 85.1736 114.262C85.6071 113.829 85.8506 113.241 85.8506 112.628V100.262C85.8506 99.6492 85.6071 99.0612 85.1737 98.6275C84.7403 98.1938 84.1524 97.95 83.5392 97.9497Z",
    fill: "url(#paint3_linear_360_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0273 110.277C81.9262 110.367 81.8058 110.433 81.6754 110.469C81.545 110.506 81.4079 110.512 81.2746 110.488C80.5195 110.324 79.7718 110.131 79.0204 109.951C78.9024 109.922 78.7935 109.863 78.7032 109.782C78.6129 109.7 78.544 109.598 78.5025 109.483C78.2651 108.933 78.1014 108.354 78.0156 107.762C77.915 107.125 77.8641 106.479 77.7883 105.838C77.778 105.776 77.7529 105.718 77.715 105.668C77.6713 105.617 77.617 105.576 77.5559 105.547C77.4948 105.519 77.4283 105.505 77.3611 105.505C77.2938 105.505 77.2273 105.519 77.1662 105.547C77.1051 105.576 77.0508 105.617 77.0071 105.668C76.9922 105.685 76.9773 105.701 76.9636 105.719C76.9372 105.767 76.9256 105.822 76.9301 105.878C76.8868 107.024 76.6802 108.158 76.3165 109.246C76.3165 109.266 76.3029 109.284 76.2966 109.304C76.2517 109.483 76.1564 109.645 76.0221 109.77C75.8877 109.896 75.72 109.98 75.539 110.014C74.8447 110.166 74.1554 110.346 73.4611 110.494C73.3306 110.519 73.1962 110.515 73.0674 110.482C72.9386 110.449 72.8186 110.388 72.7159 110.304C72.6442 110.258 72.5855 110.194 72.5451 110.118C72.5047 110.043 72.484 109.959 72.4849 109.873C72.4849 108.518 72.6786 107.198 73.214 105.943C73.5505 105.157 73.9952 104.441 74.6845 103.908C74.973 103.66 75.3337 103.513 75.7129 103.487C75.8625 103.482 76.011 103.514 76.1458 103.579C76.2807 103.643 76.398 103.74 76.4879 103.859C76.6926 104.109 76.8245 104.409 76.8692 104.729C76.8756 104.758 76.8843 104.787 76.8953 104.816L76.945 104.829C76.9854 104.751 77.0139 104.667 77.0294 104.581C77.0369 103.909 77.0294 103.238 77.0294 102.568V102.384H77.6753V102.558C77.6753 103.235 77.6753 103.91 77.6753 104.587C77.6899 104.674 77.7184 104.758 77.7597 104.836L77.8156 104.821C77.8256 104.772 77.838 104.723 77.8442 104.673C77.902 104.313 78.0766 103.981 78.341 103.73C78.618 103.448 78.9682 103.442 79.3222 103.546C79.8587 103.704 80.2562 104.063 80.6052 104.48C81.2337 105.226 81.6125 106.107 81.8658 107.043C82.1085 107.962 82.2267 108.91 82.2173 109.861C82.2199 109.94 82.2041 110.019 82.1711 110.091C82.1382 110.163 82.0889 110.227 82.0273 110.277Z",
    fill: "#111920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1011 101.552H97.8926V125.659H92.1011V101.552Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.446 121.01V125.658H100.875V121.6L109.025 112.028H101.225V107.382H116.129V111.612L108.117 121.01H116.446Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.855 121.01V125.658H118.284V121.6L126.438 112.028H118.63V107.382H133.543V111.612L125.531 121.01H133.855Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.559 107.382L148.074 125.658L145.889 131.868H140.202L142.594 125.658H140.653L134.827 107.382H140.788L144.39 121.115L148.629 107.382H154.559Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.323 119.347H157.511L155.289 125.659H151.65L160.179 101.552H164.618L173.188 125.655H169.542L167.323 119.347ZM166.249 116.332L162.433 105.44L158.583 116.33L166.249 116.332Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.814 101.659C174.814 100.133 175.993 99.0239 177.484 99.0239C178.976 99.0239 180.155 100.133 180.155 101.659C180.155 103.186 178.975 104.225 177.484 104.225C175.994 104.225 174.814 103.185 174.814 101.659ZM175.646 107.381H179.322V125.658H175.646V107.381Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_166",
    x1: 51.1906,
    y1: 116.457,
    x2: 67.8605,
    y2: 132.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DEEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_166",
    x1: 69.2545,
    y1: 116.457,
    x2: 85.9244,
    y2: 132.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DEEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_166",
    x1: 51.1906,
    y1: 98.457,
    x2: 67.8605,
    y2: 114.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DEEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_360_166",
    x1: 69.2545,
    y1: 98.4565,
    x2: 85.9244,
    y2: 114.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DEEAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.294,
    height: 34.9901,
    fill: "white",
    transform: "translate(50.7983 97.9502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrImage);
export default __webpack_public_path__ + "static/media/qr-image.f3d3984874ed405e6fd923739de34d63.svg";
export { ForwardRef as ReactComponent };